export default __webpack_public_path__ + "static/media/grip-test-score.b583601d.svg";